var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "card", attrs: { "max-width": "500" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(_vm._s(_vm.title)),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "", disabled: _vm.state == "creating" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _vm.state == "creating"
        ? _c(
            "w-card-content",
            { staticClass: "content" },
            [
              _c(
                "w-row",
                { attrs: { center: "" } },
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", center: "" } },
                    [_c("w-progress-circular")],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm.state == "done"
        ? _c(
            "w-card-content",
            { staticClass: "content" },
            [
              _c(
                "w-row",
                { attrs: { center: "" } },
                [
                  _c(
                    "w-col",
                    { attrs: { grow: "", xs: "12", center: "" } },
                    [
                      _c("app-big-download-button", {
                        attrs: { label: _vm.$ct("common.download") },
                        on: {
                          click: function ($event) {
                            return _vm.download()
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }